<template>
	<v-autocomplete
		dense
		outlined
		v-bind="$attrs"
		:item-value="'id'"
		:item-text="'title'"
		v-model="localValue"
		:items="localProjects"
		class="auto-complete-container"
	>
		<template v-slot:prepend-inner>
			<SpaceIconCard class="mr-1 icon-card">
				<SIcon :name="projectIconIndicatorName" width="10" />
			</SpaceIconCard>
		</template>
		<template v-slot:prepend-item>
			<div class="width-100 flex-align-center flex-row display-flex pl-2 spaces-header">Spaces</div>
		</template>
		<template v-slot:item="data">
			<v-list-item v-if="data.item.disabled" :disabled="data.item.disabled">
				<ProjectSelectItem :item="data.item" />
			</v-list-item>
			<ProjectSelectItem v-else :item="data.item" />
		</template>
	</v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex';

import ProjectSelectItem from '@/components/Project/ProjectSelect/ProjectSelectItem.vue';
import VModelMixin from '@/mixins/VModelMixin';
import ProjectService from '@/utils/projects-service';
import SpaceIconCard from '@/views/AppLayout/ManageAndCreate/SpaceIconCard.vue';
export default {
	name: 'ProjectSelect',
	mixins: [VModelMixin],
	components: { ProjectSelectItem, SpaceIconCard },
	props: { projects: { type: Array } },
	computed: {
		...mapGetters(['user']),
		allProjectsWithAccess() {
			return this.projects.filter((project) => !ProjectService.isSpaceWithoutAccess(project));
		},
		localProjects() {
			const personalProject = this.allProjectsWithAccess.find((x) => ProjectService.isMyPersonalProject(x, this.user)); // this is a find, instead of filter, because we limited the personal projects to be only one
			const workspaceProjects = this.allProjectsWithAccess.filter((x) => ProjectService.isWorkspaceProject(x));
			return personalProject ? [personalProject, ...workspaceProjects] : workspaceProjects;
		},
		selectedProject() {
			return this.localProjects.find((project) => project.id === this.localValue);
		},
		projectIconIndicatorName() {
			return `${this.isPersonalProject(this.selectedProject) ? 'personal' : 'collaborative'}-space`;
		},
	},
	methods: {
		isPersonalProject(project) {
			return ProjectService.isPersonalProject(project);
		},
	},
};
</script>

<style lang="scss" scoped>
.spaces-header {
	height: 31px;
	font-size: 12px;
	font-weight: 600;
	background: transparent;
	border-radius: 8px 8px 0px 0px;
	color: var(--primary-font-color);
	box-shadow: 0px 1px 2px #747f8d55;
}
.auto-complete-container {
	width: 340px;
	height: 40px;
}
.icon-card {
	margin-top: 2px;
}
</style>
